import { smtmTranslate } from "../../i18n/translatedMessages";

const ShowMeTheMoney = () => {
  return (
    <div className="conteiner-fluid sideMenuSeparator">
      <div className="row mb-4">
        <div className="col-1">
          <span className="title-icon p-2 m-auto"></span>
        </div>
        <div className="col-8">
          <h1>Por SMTM, Part of MyDNA</h1>
        </div>
      </div>
      <div className="d-flex align-items-center">
        <div className="col w-100">
          <h4 className="mt-5 mb-4">
            <strong>{smtmTranslate.smtmDesc}</strong>
          </h4>
          <div>
            <p>{smtmTranslate.smtmText1}</p>
            <p>{smtmTranslate.smtmText2}</p>
            <p className="ms-4 mt-4">
              <strong>{smtmTranslate.smtmText3}</strong>
            </p>
            <p className="ms-4 mt-4">
              <strong>{smtmTranslate.smtmText4}</strong>
            </p>
            <p className="ms-4 mt-4">
              <strong>{smtmTranslate.smtmText5}</strong>
            </p>
            <p>{smtmTranslate.smtmText6}</p>
          </div>
          <div className="smtm-button">
            <a href="https://smtm.co/dollar-bill/" target="_blank" rel="noopener noreferrer">
              <button
                className="btn rounded-pill my-3"
                style={{
                  backgroundColor: "#7A6BE8",
                  color: "white",
                  width: "300px",
                }}
              >
                {smtmTranslate.smtmBtn}
              </button>
            </a>
          </div>
        </div>
        <div className="col">
          <img className="px-5" src="https://assets.mydna.company/smtm-mascot.png" />
        </div>
      </div>
    </div>
  );
};

export default ShowMeTheMoney;
